import { render, staticRenderFns } from "./AffiliateTabs.vue?vue&type=template&id=ebe2b6ce&scoped=true&lang=pug&"
import script from "./AffiliateTabs.vue?vue&type=script&lang=js&"
export * from "./AffiliateTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe2b6ce",
  null
  
)

export default component.exports